module.exports = __webpack_public_path__ + "img/43_86.5d07e526.png";